module.exports = "/_next/static/images/abc7-69171702f7fb1c224e579d476d8b6881.png";